import { Link } from "react-router-dom";

/**
 * Checkbox "AGB akzeptieren" + Hinweise, wird vor dem Kaufen-Button auf allen
 * Buchungs-Seiten angezeigt (Silvester, Eisstock, Gutschein).
 *
 * Props:
 *  - checked: boolean
 *  - onChange: (v: boolean) => void
 *  - testId?: string (base, default "agb")
 */
const TermsAcceptance = ({ checked, onChange, testId = "agb" }) => {
  return (
    <div className="space-y-3" data-testid={`${testId}-block`}>
      <label className="flex items-start gap-3 cursor-pointer bg-slate-50 border border-slate-200 rounded-xl p-4 hover:bg-slate-100 transition-colors">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 w-5 h-5 accent-sky-500 cursor-pointer flex-shrink-0"
          data-testid={`${testId}-checkbox`}
        />
        <span className="text-sm text-slate-700 leading-relaxed">
          Ich habe die{" "}
          <Link
            to="/agb"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sky-600 underline hover:text-sky-700 font-medium"
            data-testid={`${testId}-agb-link`}
          >
            AGB
          </Link>{" "}
          sowie die Hinweise zum Widerrufsrecht gelesen und akzeptiere diese.
          <br />
          Mir ist bekannt, dass für termingebundene Tickets kein Widerrufsrecht besteht. Gutscheine
          sind Wertgutscheine und nicht für gastronomische Leistungen einlösbar.
        </span>
      </label>
    </div>
  );
};

export default TermsAcceptance;
